export default "/images/d58e0c0c570878c3819d958f887b6b40.avif";